import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.dataDashboard || initialState;

export const selectDataDashboard = createSelector(
  [selectDomain],
  dataDashboardState => dataDashboardState,
);
